const allCities = [{
    pcode: '15',
    city: '阿拉善',
    code: '152900',
    level: 1,
    initial: 'A',
    lonlat: "105.69018,38.84121",
    short: 'Alashanmeng'
}, {
    pcode: '21',
    city: '鞍山',
    code: '210300',
    level: 1,
    initial: 'A',
    lonlat: "122.98945,41.10662",
    short: 'Anshan'
}, {
    pcode: '34',
    city: '安庆',
    code: '340800',
    level: 1,
    initial: 'A',
    lonlat: "117.05181,30.52717",
    short: 'Anqing'
}, {
    pcode: '41',
    city: '安阳',
    code: '410500',
    level: 1,
    initial: 'A',
    lonlat: "114.34614,36.09561",
    short: 'Anyang'
}, {
    pcode: '51',
    city: '阿坝州',
    code: '513200',
    level: 1,
    initial: 'A',
    short: 'Aba',
    lonlat:"102.22055,31.901"
}, {
    pcode: '52',
    city: '安顺',
    code: '520400',
    level: 1,
    initial: 'A',
    lonlat:"105.93401,26.24562",
    short: 'Anshun'
}, {
    pcode: '54',
    city: '阿里地区',
    code: '542500',
    level: 1,
    initial: 'A',
    lonlat:"81.15743,30.32246",
    short: 'Ali'
}, {
    pcode: '61',
    city: '安康',
    code: '610900',
    level: 1,
    initial: 'A',
    lonlat:"109.02352,32.68774",
    short: 'Ankang'
}, {
    pcode: '65',
    city: '阿克苏地区',
    code: '652900',
    level: 1,
    initial: 'A',
    lonlat:"80.27195,41.16968",
    short: 'Akesu'
}, {
    pcode: '65',
    city: '阿勒泰地区',
    code: '654300',
    level: 1,
    initial: 'A',
    lonlat:"88.13516,47.84743",
    short: 'Aletai'
}, {
    pcode: '90',
    city: '澳门',
    code: '900200',
    level: 2,
    initial: 'A',
    lonlat:"113.5461,22.19414",
    short: 'Aomen'
}, {
    pcode: '11',
    city: '北京',
    code: '110000',
    level: 1,
    initial: 'B',
    lonlat:"116.39,39.90496",
    short: 'Beijing'
}, {
    pcode: '13',
    city: '保定',
    code: '130600',
    level: 1,
    initial: 'B',
    lonlat:"115.48452,38.86712",
    short: 'Baoding'
}, {
    pcode: '15',
    city: '包头',
    code: '150200',
    level: 1,
    initial: 'B',
    lonlat:"109.83454,40.65621",
    short: 'Baotou'
}, {
    pcode: '15',
    city: '巴彦淖尔',
    code: '150800',
    level: 1,
    initial: 'B',
    lonlat:"107.40448,40.7536",
    short: 'Bayannaoer'
}, {
    pcode: '21',
    city: '本溪',
    code: '210500',
    level: 1,
    initial: 'B',
    lonlat:"123.76097,41.29204",
    short: 'Benxi'
}, {
    pcode: '22',
    city: '白山',
    code: '220600',
    level: 1,
    initial: 'B',
    lonlat:"126.4375,41.9375",
    short: 'Baishan'
}, {
    pcode: '22',
    city: '白城',
    code: '220800',
    level: 1,
    initial: 'B',
    lonlat:"122.83558,45.6159",
    short: 'Baicheng'
}, {
    pcode: '34',
    city: '蚌埠',
    code: '340300',
    level: 1,
    initial: 'B',
    lonlat:"117.35312,32.93537",
    short: 'Bangbu'
}, {
    pcode: '37',
    city: '滨州',
    code: '371600',
    level: 1,
    initial: 'B',
    lonlat: "118.00056,37.38662",
    short: 'Binzhou'
}, {
    pcode: '45',
    city: '北海',
    code: '450500',
    level: 1,
    initial: 'B',
    lonlat:"109.12329,21.45376",
    short: 'Beihai'
}, {
    pcode: '45',
    city: '百色',
    code: '451000',
    level: 1,
    initial: 'B',
    lonlat:"106.61442,23.89949",
    short: 'Baise'
}, {
    pcode: '51',
    city: '巴中',
    code: '511900',
    level: 1,
    initial: 'B',
    lonlat:"106.75586,31.85764",
    short: 'Bazhong'
}, {
    pcode: '52',
    city: '毕节',
    code: '522400',
    level: 1,
    initial: 'B',
    lonlat:"105.28092,27.30947",
    short: 'Bijie'
}, {
    pcode: '53',
    city: '保山',
    code: '530500',
    level: 1,
    initial: 'B',
    lonlat:"99.1609,25.11508",
    short: 'Baoshan'
}, {
    pcode: '61',
    city: '宝鸡',
    code: '610300',
    level: 1,
    initial: 'B',
    lonlat:"107.20552,34.36197",
    short: 'Baoji'
}, {
    pcode: '62',
    city: '白银',
    code: '620400',
    level: 1,
    initial: 'B',
    lonlat:"104.17834,36.54702",
    short: 'Baiyin'
}, {
    pcode: '65',
    city: '博尔塔拉州',
    code: '652700',
    level: 1,
    initial: 'B',
    lonlat:"82.06618,44.89288",
    short: 'Boertala'
}, {
    pcode: '65',
    city: '巴音郭楞州',
    code: '652800',
    level: 1,
    initial: 'B',
    lonlat:"86.15252,41.76401",
    short: 'Bayinguoleng'
}, {
    pcode: '50',
    city: '重庆',
    code: '500000',
    level: 1,
    initial: 'C',
    lonlat:"106.52713,29.52744",
    short: 'Chongqing'
}, {
    pcode: '13',
    city: '承德',
    code: '130800',
    level: 1,
    initial: 'C',
    lonlat:"117.93211,40.97402",
    short: 'Chengde'
}, {
    pcode: '13',
    city: '沧州',
    code: '130900',
    level: 1,
    initial: 'C',
    lonlat:"116.85496,38.32772",
    short: 'Cangzhou'
}, {
    pcode: '14',
    city: '长治',
    code: '140400',
    level: 1,
    initial: 'C',
    lonlat:"113.10075,36.18972",
    short: 'Changzhi'
}, {
    pcode: '15',
    city: '赤峰',
    code: '150400',
    level: 1,
    initial: 'C',
    lonlat:"118.94544,42.27112",
    short: 'Chifeng'
}, {
    pcode: '21',
    city: '朝阳',
    code: '211300',
    level: 1,
    initial: 'C',
    lonlat:"120.44856,41.57567",
    short: 'Chaoyang'
}, {
    pcode: '22',
    city: '长春',
    code: '220100',
    level: 5,
    initial: 'C',
    lonlat:"125.30831,43.8843",
    short: 'Changchun'
}, {
    pcode: '32',
    city: '常州',
    code: '320400',
    level: 1,
    initial: 'C',
    lonlat:"119.95071,31.78353",
    short: 'Changzhou'
}, {
    pcode: '34',
    city: '滁州',
    code: '341100',
    level: 1,
    initial: 'C',
    lonlat:"118.31148,32.30621",
    short: 'Chuzhou'
}, {
    pcode: '34',
    city: '巢湖',
    code: '341400',
    level: 1,
    initial: 'C',
    lonlat:"117.85646,31.6009",
    short: 'Chaohu'
}, {
    pcode: '34',
    city: '池州',
    code: '341700',
    level: 1,
    initial: 'C',
    lonlat:"117.48224,30.6637",
    short: 'Chizhou'
}, {
    pcode: '43',
    city: '长沙',
    code: '430100',
    level: 5,
    initial: 'C',
    lonlat:"112.97811,28.19746",
    short: 'Changsha'
}, {
    pcode: '43',
    city: '常德',
    code: '430700',
    level: 1,
    initial: 'C',
    lonlat:"111.68547,29.01893",
    short: 'Changde'
}, {
    pcode: '43',
    city: '郴州',
    code: '431000',
    level: 1,
    initial: 'C',
    lonlat:"113.02264,25.8072",
    short: 'Chenzhou'
}, {
    pcode: '44',
    city: '潮州',
    code: '445100',
    level: 1,
    initial: 'C',
    lonlat:"116.6186,23.65945",
    short: 'Chaozhou'
}, {
    pcode: '45',
    city: '崇左',
    code: '451400',
    level: 1,
    initial: 'C',
    lonlat:"107.36648,22.38592",
    short: 'Chongzuo'
}, {
    pcode: '51',
    city: '成都',
    code: '510100',
    level: 5,
    initial: 'C',
    lonlat:"104.06247,30.66093",
    short: 'Chengdu'
}, {
    pcode: '53',
    city: '楚雄州',
    code: '532300',
    level: 1,
    initial: 'C',
    lonlat:"101.54635,25.03666",
    short: 'Chuxiong'
}, {
    pcode: '54',
    city: '昌都市',
    code: '542100',
    level: 1,
    initial: 'C',
    lonlat:"97.17767,31.13749",
    short: 'Changdu'
}, {
    pcode: '65',
    city: '昌吉州',
    code: '652300',
    level: 1,
    initial: 'C',
    lonlat:"87.30595,44.00135",
    short: 'Changji'
}, {
    pcode: '14',
    city: '大同',
    code: '140200',
    level: 1,
    initial: 'D',
    lonlat:"113.28883,40.09079",
    short: 'Datong'
}, {
    pcode: '21',
    city: '大连',
    code: '210200',
    level: 1,
    initial: 'D',
    lonlat:"121.61,38.91319",
    short: 'Dalian'
}, {
    pcode: '21',
    city: '丹东',
    code: '210600',
    level: 1,
    initial: 'D',
    lonlat:"124.37912,40.12537",
    short: 'Dandong'
}, {
    pcode: '23',
    city: '大庆',
    code: '230600',
    level: 1,
    initial: 'D',
    lonlat:"125.02508,46.59178",
    short: 'Daqing'
}, {
    pcode: '23',
    city: '大兴安岭地区',
    code: '232700',
    level: 1,
    initial: 'D',
    lonlat:"124.11013,50.40913",
    short: 'Daxinganling'
}, {
    pcode: '37',
    city: '东营',
    code: '370500',
    level: 1,
    initial: 'D',
    lonlat:"118.57602,37.45643",
    short: 'Dongying'
}, {
    pcode: '37',
    city: '德州',
    code: '371400',
    level: 1,
    initial: 'D',
    lonlat:"116.29659,37.44995",
    short: 'Dezhou'
}, {
    pcode: '44',
    city: '东莞',
    code: '441900',
    level: 1,
    initial: 'D',
    lonlat:"113.74928,23.04749",
    short: 'Dongguan'
}, {
    pcode: '51',
    city: '德阳',
    code: '510600',
    level: 1,
    initial: 'D',
    lonlat:"104.39499,31.12892",
    short: 'Deyang'
}, {
    pcode: '51',
    city: '达州',
    code: '511700',
    level: 1,
    initial: 'D',
    lonlat:"107.47826,31.21058",
    short: 'Dazhou'
}, {
    pcode: '53',
    city: '大理州',
    code: '532900',
    level: 1,
    initial: 'D',
    lonlat:"100.22242,25.59324",
    short: 'Dali'
}, {
    pcode: '53',
    city: '德宏州',
    code: '533100',
    level: 1,
    initial: 'D',
    lonlat:"98.58488,24.43546",
    short: 'Dehong'
}, {
    pcode: '53',
    city: '迪庆州',
    code: '533400',
    level: 1,
    initial: 'D',
    lonlat:"99.70535,27.82629",
    short: 'Diqing'
}, {
    pcode: '62',
    city: '定西',
    code: '621100',
    level: 1,
    initial: 'D',
    lonlat:"104.62195,35.581835",
    short: 'Dingxi'
}, {
    pcode: '15',
    city: '鄂尔多斯',
    code: '150600',
    level: 1,
    initial: 'E',
    lonlat:"109.9976,39.81488",
    short: 'Eerduosi'
}, {
    pcode: '42',
    city: '鄂州',
    code: '420700',
    level: 1,
    initial: 'E',
    lonlat:"114.88127,30.401",
    short: 'Ezhou'
}, {
    pcode: '42',
    city: '恩施州',
    code: '422800',
    level: 1,
    initial: 'E',
    lonlat:"109.48025,30.28391",
    short: 'Enshi'
}, {
    pcode: '21',
    city: '抚顺',
    code: '210400',
    level: 1,
    initial: 'F',
    lonlat:"123.91793,41.87279",
    short: 'Fushun'
}, {
    pcode: '21',
    city: '阜新',
    code: '210900',
    level: 1,
    initial: 'F',
    lonlat:"121.64739,42.00827",
    short: 'Fuxin'
}, {
    pcode: '34',
    city: '阜阳',
    code: '341200',
    level: 1,
    initial: 'F',
    lonlat:"115.82881,32.90309",
    short: 'Fuyang'
}, {
    pcode: '35',
    city: '福州',
    code: '350100',
    level: 1,
    initial: 'F',
    lonlat:"119.2918,26.07713",
    short: 'Fuzhou'
}, {
    pcode: '36',
    city: '抚州',
    code: '361000',
    level: 1,
    initial: 'F',
    lonlat:"116.34806,28.00222",
    short: 'Fuzhou'
}, {
    pcode: '44',
    city: '佛山',
    code: '440600',
    level: 1,
    initial: 'F',
    lonlat:"113.09785,23.02963",
    short: 'Foshan'
}, {
    pcode: '45',
    city: '防城港',
    code: '450600',
    level: 1,
    initial: 'F',
    lonlat:"108.34041,21.61559",
    short: 'Fangchenggang'
}, {
    pcode: '36',
    city: '赣州',
    code: '360700',
    level: 1,
    initial: 'G',
    lonlat:"114.93514,25.857",
    short: 'Ganzhou'
}, {
    pcode: '44',
    city: '广州',
    code: '440100',
    level: 5,
    initial: 'G',
    lonlat:"113.25903,23.13152",
    short: 'Guangzhou'
}, {
    pcode: '45',
    city: '桂林',
    code: '450300',
    level: 1,
    initial: 'G',
    lonlat:"110.2856,25.27654",
    short: 'Guilin'
}, {
    pcode: '45',
    city: '贵港',
    code: '450800',
    level: 1,
    initial: 'G',
    lonlat:"109.60019,23.09323",
    short: 'Guigang'
}, {
    pcode: '51',
    city: '广元',
    code: '510800',
    level: 1,
    initial: 'G',
    lonlat:"105.82209,32.43514",
    short: 'Guangyuan'
}, {
    pcode: '51',
    city: '广安',
    code: '511600',
    level: 1,
    initial: 'G',
    lonlat:"106.63945,30.47057",
    short: 'Guangan'
}, {
    pcode: '51',
    city: '甘孜州',
    code: '513300',
    level: 1,
    initial: 'G',
    lonlat:"101.96288,30.0525",
    short: 'Ganzi'
}, {
    pcode: '52',
    city: '贵阳',
    code: '520100',
    level: 5,
    initial: 'G',
    lonlat:"106.70786,26.57942",
    short: 'Guiyang'
}, {
    pcode: '62',
    city: '甘南州',
    code: '623000',
    level: 1,
    initial: 'G',
    lonlat:"102.90975,34.98449",
    short: 'Gannan'
}, {
    pcode: '63',
    city: '果洛州',
    code: '632600',
    level: 1,
    initial: 'G',
    lonlat:"100.24441,34.47168",
    short: 'Guoluo'
}, {
    pcode: '64',
    city: '固原',
    code: '640400',
    level: 1,
    initial: 'G',
    lonlat:"106.28308,36.00636",
    short: 'Guyuan'
}, {
    pcode: '13',
    city: '邯郸',
    code: '130400',
    level: 1,
    initial: 'H',
    lonlat:"114.47136,36.59331",
    short: 'Handan'
}, {
    pcode: '13',
    city: '衡水',
    code: '131100',
    level: 1,
    initial: 'H',
    lonlat:"115.68599,37.73484",
    short: 'Hengshui'
}, {
    pcode: '37',
    city: '菏泽',
    code: '371700',
    level: 1,
    initial: 'H',
    lonlat:"115.48303,35.24935",
    short: 'Heze'
}, {
    pcode: '15',
    city: '呼和浩特',
    code: '150100',
    level: 5,
    initial: 'H',
    lonlat:"111.66293,40.81507",
    short: 'Huhehaote'
}, {
    pcode: '15',
    city: '呼伦贝尔',
    code: '150700',
    level: 1,
    initial: 'H',
    lonlat:"119.75097,49.21534",
    short: 'Hulunbeier'
}, {
    pcode: '21',
    city: '葫芦岛',
    code: '211400',
    level: 1,
    initial: 'H',
    lonlat:"120.83181,40.70954",
    short: 'Huludao'
}, {
    pcode: '23',
    city: '哈尔滨',
    code: '230100',
    level: 5,
    initial: 'H',
    lonlat:"126.64452,45.7421",
    short: 'Haerbin'
}, {
    pcode: '23',
    city: '鹤岗',
    code: '230400',
    level: 1,
    initial: 'H',
    lonlat:"130.26958,47.32799",
    short: 'Hegang'
}, {
    pcode: '23',
    city: '黑河',
    code: '231100',
    level: 1,
    initial: 'H',
    lonlat:"127.48942,50.24292",
    short: 'Heihe'
}, {
    pcode: '32',
    city: '淮安',
    code: '320800',
    level: 1,
    initial: 'H',
    lonlat:"119.03185,33.59935",
    short: 'Huaian'
}, {
    pcode: '33',
    city: '杭州',
    code: '330100',
    level: 5,
    initial: 'H',
    lonlat:"120.15047,30.27536",
    short: 'Hangzhou'
}, {
    pcode: '33',
    city: '湖州',
    code: '330500',
    level: 1,
    initial: 'H',
    lonlat:"120.09581,30.86945",
    short: 'Huzhou'
}, {
    pcode: '34',
    city: '合肥',
    code: '340100',
    level: 5,
    initial: 'H',
    lonlat:"117.2821,31.86714",
    short: 'Hefei'
}, {
    pcode: '34',
    city: '淮南',
    code: '340400',
    level: 1,
    initial: 'H',
    lonlat:"116.94969,32.63307",
    short: 'Huainan'
}, {
    pcode: '34',
    city: '淮北',
    code: '340600',
    level: 1,
    initial: 'H',
    lonlat:"116.78496,33.94568",
    short: 'Huaibei'
}, {
    pcode: '34',
    city: '黄山',
    code: '341000',
    level: 1,
    initial: 'H',
    lonlat:"118.30895,29.71454",
    short: 'Huangshan'
}, {
    pcode: '34',
    city: '亳州',
    code: '341600',
    level: 1,
    initial: 'B',
    lonlat:"115.77861,33.86968",
    short: 'Bozhou'
}, {
    pcode: '41',
    city: '鹤壁',
    code: '410600',
    level: 1,
    initial: 'H',
    lonlat:"114.28943,35.74865",
    short: 'Hebi'
}, {
    pcode: '42',
    city: '黄石',
    code: '420200',
    level: 1,
    initial: 'H',
    lonlat:"115.03262,30.20178",
    short: 'Huangshi'
}, {
    pcode: '42',
    city: '黄冈',
    code: '421100',
    level: 1,
    initial: 'H',
    lonlat:"114.8888,30.45212",
    short: 'Huanggang'
}, {
    pcode: '43',
    city: '衡阳',
    code: '430400',
    level: 1,
    initial: 'H',
    lonlat:"112.58178,26.90074",
    short: 'Hengyang'
}, {
    pcode: '43',
    city: '怀化',
    code: '431200',
    level: 1,
    initial: 'H',
    lonlat:"109.97008,27.55018",
    short: 'Huaihua'
}, {
    pcode: '44',
    city: '惠州',
    code: '441300',
    level: 1,
    initial: 'H',
    lonlat:"114.40693,23.08319",
    short: 'Huizhou'
}, {
    pcode: '44',
    city: '河源',
    code: '441600',
    level: 1,
    initial: 'H',
    lonlat:"114.68678,23.73921",
    short: 'Heyuan'
}, {
    pcode: '45',
    city: '贺州',
    code: '451100',
    level: 1,
    initial: 'H',
    lonlat:"111.54648,24.41653",
    short: 'Hezhou'
}, {
    pcode: '45',
    city: '河池',
    code: '451200',
    level: 1,
    initial: 'H',
    lonlat:"108.0584,24.69892",
    short: 'Hechi'
}, {
    pcode: '46',
    city: '海口',
    code: '460100',
    level: 5,
    initial: 'H',
    lonlat:"110.32398,20.03342",
    short: 'Haikou'
}, {
    pcode: '53',
    city: '红河州',
    code: '532500',
    level: 1,
    initial: 'H',
    lonlat:"103.37281,23.36963",
    short: 'Honghe'
}, {
    pcode: '61',
    city: '汉中',
    code: '610700',
    level: 1,
    initial: 'H',
    lonlat:"107.02598,33.07938",
    short: 'Hanzhong'
}, {
    pcode: '63',
    city: '海东地区',
    code: '632100',
    level: 1,
    initial: 'H',
    lonlat:"102.10315,36.50145",
    short: 'Haidong'
}, {
    pcode: '63',
    city: '海北州',
    code: '632200',
    level: 1,
    initial: 'H',
    lonlat:"100.89979,36.95613",
    short: 'Haibei'
}, {
    pcode: '63',
    city: '黄南州',
    code: '632300',
    level: 1,
    initial: 'H',
    lonlat:"102.01678,35.51563",
    short: 'Huangnan'
}, {
    pcode: '63',
    city: '海南州',
    code: '632500',
    level: 1,
    initial: 'H',
    lonlat:"100.61747,36.27352",
    short: 'Hainan'
}, {
    pcode: '63',
    city: '海西州',
    code: '632800',
    level: 1,
    initial: 'H',
    lonlat:"97.36787,37.37295",
    short: 'Haixi'
}, {
    pcode: '65',
    city: '哈密地区',
    code: '652200',
    level: 1,
    initial: 'H',
    lonlat:"93.51548,42.83224",
    short: 'Hami'
}, {
    pcode: '65',
    city: '和田地区',
    code: '653200',
    level: 1,
    initial: 'H',
    lonlat:"79.92484,37.10913",
    short: 'Hetiandi'
}, {
    pcode: '14',
    city: '晋城',
    code: '140500',
    level: 1,
    initial: 'J',
    lonlat:"112.84382,35.49666",
    short: 'Jincheng'
}, {
    pcode: '14',
    city: '晋中',
    code: '140700',
    level: 1,
    initial: 'J',
    lonlat:"112.74164,37.69332",
    short: 'Jinzhong'
}, {
    pcode: '21',
    city: '锦州',
    code: '210700',
    level: 1,
    initial: 'J',
    lonlat:"121.13354,41.12256",
    short: 'Jinzhou'
}, {
    pcode: '22',
    city: '吉林',
    code: '220200',
    level: 1,
    initial: 'J',
    lonlat:"126.56175,43.84983",
    short: 'Jilin'
}, {
    pcode: '23',
    city: '鸡西',
    code: '230300',
    level: 1,
    initial: 'J',
    lonlat:"130.96496,45.29366",
    short: 'Jixi'
}, {
    pcode: '23',
    city: '佳木斯',
    code: '230800',
    level: 1,
    initial: 'J',
    lonlat:"130.35141,46.80602",
    short: 'Jiamusi'
}, {
    pcode: '33',
    city: '嘉兴',
    code: '330400',
    level: 1,
    initial: 'J',
    lonlat:"120.75284,30.76613",
    short: 'Jiaxing'
}, {
    pcode: '33',
    city: '金华',
    code: '330700',
    level: 1,
    initial: 'J',
    lonlat:"119.64937,29.10462",
    short: 'Jinhua'
}, {
    pcode: '36',
    city: '景德镇',
    code: '360200',
    level: 1,
    initial: 'J',
    lonlat:"117.208,29.29016",
    short: 'Jingdezhen'
}, {
    pcode: '36',
    city: '九江',
    code: '360400',
    level: 1,
    initial: 'J',
    lonlat:"116.01809,29.70752",
    short: 'Jiujiang'
}, {
    pcode: '36',
    city: '吉安',
    code: '360800',
    level: 1,
    initial: 'J',
    lonlat:"114.96437,27.12363",
    short: 'Jian'
}, {
    pcode: '37',
    city: '济南',
    code: '370100',
    level: 5,
    initial: 'J',
    lonlat:"116.9895,36.66519",
    short: 'Jinan'
}, {
    pcode: '37',
    city: '济宁',
    code: '370800',
    level: 1,
    initial: 'J',
    lonlat:"116.58209,35.41497",
    short: 'Jining'
}, {
    pcode: '41',
    city: '焦作',
    code: '410800',
    level: 1,
    initial: 'J',
    lonlat:"113.2304,35.22904",
    short: 'Jiaozuo'
}, {
    pcode: '42',
    city: '荆门',
    code: '420800',
    level: 1,
    initial: 'J',
    lonlat:"112.21134,31.03805",
    short: 'Jingmen'
}, {
    pcode: '42',
    city: '荆州',
    code: '421000',
    level: 1,
    initial: 'J',
    lonlat:"112.23613,30.32448",
    short: 'Jingzhou'
}, {
    pcode: '44',
    city: '江门',
    code: '440700',
    level: 1,
    initial: 'J',
    lonlat:"113.11424,22.59663",
    short: 'Jiangmen'
}, {
    pcode: '44',
    city: '揭阳',
    code: '445200',
    level: 1,
    initial: 'J',
    lonlat:"116.35569,23.5502",
    short: 'Jieyang'
}, {
    pcode: '62',
    city: '嘉峪关',
    code: '620200',
    level: 1,
    initial: 'J',
    lonlat:"98.27287,39.79921",
    short: 'Jiayuguan'
}, {
    pcode: '62',
    city: '金昌',
    code: '620300',
    level: 1,
    initial: 'J',
    lonlat:"102.19175,38.51086",
    short: 'Jinchang'
}, {
    pcode: '62',
    city: '酒泉',
    code: '620900',
    level: 1,
    initial: 'J',
    lonlat:"98.51283,39.74332",
    short: 'Jiuquan'
}, {
    pcode: '41',
    city: '开封',
    code: '410200',
    level: 1,
    initial: 'K', 
    lonlat:"114.34034,34.79357",
    short: 'Kaifeng'
}, {
    pcode: '53',
    city: '昆明',
    code: '530100',
    level: 5,
    initial: 'K', 
    lonlat:"102.71043,25.04691",
    short: 'Kunming'
}, {
    pcode: '65',
    city: '克拉玛依',
    code: '650200',
    level: 1,
    initial: 'K', 
    lonlat:"84.87442,45.59885",
    short: 'Kelamayi'
}, {
    pcode: '65',
    city: '克孜勒苏州',
    code: '653000',
    level: 1,
    initial: 'K', 
    lonlat:"76.17176,39.71314",
    short: 'Kezilesu'
}, {
    pcode: '65',
    city: '喀什地区',
    code: '653100',
    level: 1,
    initial: 'K', 
    lonlat:"75.98924,39.46816",
    short: 'Kashidi'
}, {
    pcode: '13',
    city: '廊坊',
    code: '131000',
    level: 1,
    initial: 'L',
    lonlat:"116.69091,39.51812",
    short: 'Langfang'
}, {
    pcode: '14',
    city: '临汾',
    code: '141000',
    level: 1,
    initial: 'L',
    lonlat:"111.51899,36.08054",
    short: 'Linfen'
}, {
    pcode: '14',
    city: '吕梁',
    code: '141100',
    level: 1,
    initial: 'L',
    lonlat:"111.14157,37.52003",
    short: 'Lvliang'
}, {
    pcode: '21',
    city: '辽阳',
    code: '211000',
    level: 1,
    initial: 'L',
    lonlat:"123.1772,41.26432",
    short: 'Liaoyang'
}, {
    pcode: '22',
    city: '辽源',
    code: '220400',
    level: 1,
    initial: 'L',
    lonlat:"125.14025,42.90068",
    short: 'Liaoyuan'
}, {
    pcode: '32',
    city: '连云港',
    code: '320700',
    level: 1,
    initial: 'L',
    lonlat:"119.17499,34.59923",
    short: 'Lianyungang'
}, {
    pcode: '33',
    city: '丽水',
    code: '331100',
    level: 1,
    initial: 'L',
    lonlat:"119.93541,28.44563",
    short: 'Lishui'
}, {
    pcode: '34',
    city: '六安',
    code: '341500',
    level: 1,
    initial: 'L',
    lonlat:"116.50755,31.75737",
    short: 'Liuan'
}, {
    pcode: '35',
    city: '龙岩',
    code: '350800',
    level: 1,
    initial: 'L',
    lonlat:"117.03047,25.09715",
    short: 'Longyan'
}, {
    pcode: '37',
    city: '莱芜',
    code: '371200',
    level: 1,
    initial: 'L',
    lonlat:"117.65447,36.20322",
    short: 'Laiwu'
}, {
    pcode: '37',
    city: '临沂',
    code: '371300',
    level: 1,
    initial: 'L',
    lonlat:"118.34679,35.05077",
    short: 'Linyi'
}, {
    pcode: '37',
    city: '聊城',
    code: '371500',
    level: 1,
    initial: 'L',
    lonlat:"115.97964,36.45695",
    short: 'Liaocheng'
}, {
    pcode: '41',
    city: '洛阳',
    code: '410300',
    level: 1,
    initial: 'L',
    lonlat:"112.44799,34.61727",
    short: 'Luoyang'
}, {
    pcode: '41',
    city: '漯河',
    code: '411100',
    level: 1,
    initial: 'L',
    lonlat:"114.0109,33.58299",
    short: 'Luohe'
}, {
    pcode: '43',
    city: '娄底',
    code: '431300',
    level: 1,
    initial: 'L',
    lonlat:"111.99742,27.73776",
    short: 'Loudi'
}, {
    pcode: '45',
    city: '柳州',
    code: '450200',
    level: 1,
    initial: 'L',
    lonlat:"109.41087,24.32812",
    short: 'Liuzhou'
}, {
    pcode: '45',
    city: '来宾',
    code: '451300',
    level: 1,
    initial: 'L',
    lonlat:"109.23056,23.73444",
    short: 'Laibin'
}, {
    pcode: '51',
    city: '泸州',
    code: '510500',
    level: 1,
    initial: 'L',
    lonlat:"105.44093,28.89182",
    short: 'Luzhou'
}, {
    pcode: '51',
    city: '乐山',
    code: '511100',
    level: 1,
    initial: 'L',
    lonlat:"103.756,29.56706",
    short: 'Leshan'
}, {
    pcode: '51',
    city: '凉山州',
    code: '513400',
    level: 1,
    initial: 'L',
    lonlat:"102.26343,27.89",
    short: 'Liangshan'
}, {
    pcode: '52',
    city: '六盘水',
    code: '520200',
    level: 1,
    initial: 'L',
    lonlat:"104.85949,26.58473",
    short: 'Liupanshui'
}, {
    pcode: '53',
    city: '丽江',
    code: '530700',
    level: 1,
    initial: 'L',
    lonlat:"100.22428,26.88019",
    short: 'Lijiang'
}, {
    pcode: '53',
    city: '临沧',
    code: '530900',
    level: 1,
    initial: 'L',
    lonlat:"100.08757,23.88147",
    short: 'Lincang'
}, {
    pcode: '54',
    city: '拉萨',
    code: '540100',
    level: 5,
    initial: 'L',
    lonlat:"91.13457,29.65145",
    short: 'Lasa'
}, {
    pcode: '54',
    city: '林芝',
    code: '542600',
    level: 1,
    initial: 'L',
    lonlat:"94.35936,29.65973",
    short: 'Linzhi'
}, {
    pcode: '62',
    city: '兰州',
    code: '620100',
    level: 5,
    initial: 'L',
    lonlat:"103.83177,36.06171",
    short: 'Lanzhou'
}, {
    pcode: '62',
    city: '陇南',
    code: '621200',
    level: 1,
    initial: 'L',
    lonlat:"104.9272,33.38975",
    short: 'Longnan'
}, {
    pcode: '62',
    city: '临夏州',
    code: '622900',
    level: 1,
    initial: 'L',
    lonlat:"103.21033,35.59537",
    short: 'Linxia'
}, {
    pcode: '23',
    city: '牡丹江',
    code: '231000',
    level: 1,
    initial: 'M',
    lonlat:"129.61841,44.58224",
    short: 'Mudanjiang'
}, {
    pcode: '34',
    city: '马鞍山',
    code: '340500',
    level: 1,
    initial: 'M',
    lonlat:"118.49443,31.70617",
    short: 'Maanshan'
}, {
    pcode: '44',
    city: '茂名',
    code: '440900',
    level: 1,
    initial: 'M',
    lonlat:"110.88002,21.66561",
    short: 'Maoming'
}, {
    pcode: '44',
    city: '梅州',
    code: '441400',
    level: 1,
    initial: 'M',
    lonlat:"116.09539,24.29128",
    short: 'Meizhou'
}, {
    pcode: '51',
    city: '绵阳',
    code: '510700',
    level: 1,
    initial: 'M',
    lonlat:"104.73847,31.46688",
    short: 'Mianyang'
}, {
    pcode: '51',
    city: '眉山',
    code: '511400',
    level: 1,
    initial: 'M',
    lonlat:"103.84646,30.07823",
    short: 'Meishan'
}, {
    pcode: '32',
    city: '南京',
    code: '320100',
    level: 5,
    initial: 'N',
    lonlat:"118.79128,32.06045",
    short: 'Nanjing'
}, {
    pcode: '32',
    city: '南通',
    code: '320600',
    level: 1,
    initial: 'N',
    lonlat:"120.8873,31.98288",
    short: 'Nantong'
}, {
    pcode: '33',
    city: '宁波',
    code: '330200',
    level: 1,
    initial: 'N',
    lonlat:"121.5456,29.87668",
    short: 'Ningbo'
}, {
    pcode: '35',
    city: '南平',
    code: '350700',
    level: 1,
    initial: 'N',
    lonlat:"118.17282,26.64481",
    short: 'Nanping'
}, {
    pcode: '35',
    city: '宁德',
    code: '350900',
    level: 1,
    initial: 'N',
    lonlat:"119.53699,26.65533",
    short: 'Ningde'
}, {
    pcode: '36',
    city: '南昌',
    code: '360100',
    level: 5,
    initial: 'N',
    lonlat:"115.89732,28.67417",
    short: 'Nanchang'
}, {
    pcode: '41',
    city: '南阳',
    code: '411300',
    level: 1,
    initial: 'N',
    lonlat:"112.52618,33.00341",
    short: 'Nanyang'
}, {
    pcode: '45',
    city: '南宁',
    code: '450100',
    level: 5,
    initial: 'N',
    lonlat:"108.36257,22.81909",
    short: 'Nanning'
}, {
    pcode: '51',
    city: '内江',
    code: '511000',
    level: 1,
    initial: 'N',
    lonlat:"105.04961,29.58506",
    short: 'Neijiang'
}, {
    pcode: '51',
    city: '南充',
    code: '511300',
    level: 1,
    initial: 'N',
    lonlat:"106.07843,30.79913",
    short: 'Nanchong'
}, {
    pcode: '53',
    city: '怒江州',
    code: '533300',
    level: 1,
    initial: 'N',
    lonlat:"98.85767,25.84899",
    short: 'Nujiang'
}, {
    pcode: '54',
    city: '那曲',
    code: '542400',
    level: 1,
    initial: 'N',
    lonlat:"92.05691,31.47665",
    short: 'Naqu'
}, {
    pcode: '21',
    city: '盘锦',
    code: '211100',
    level: 1,
    initial: 'P',
    lonlat:"122.06339,41.11983",
    short: 'Panjin'
}, {
    pcode: '35',
    city: '莆田',
    code: '350300',
    level: 1,
    initial: 'P',
    lonlat:"119.00757,25.43865",
    short: 'Putian'
}, {
    pcode: '36',
    city: '萍乡',
    code: '360300',
    level: 1,
    initial: 'P',
    lonlat:"113.84541,27.62794",
    short: 'Pingxiang'
}, {
    pcode: '41',
    city: '平顶山',
    code: '410400',
    level: 1,
    initial: 'P',
    lonlat:"113.29544,33.74258",
    short: 'Pingdingshan'
}, {
    pcode: '41',
    city: '濮阳',
    code: '410900',
    level: 1,
    initial: 'P',
    lonlat:"115.04958,35.75291",
    short: 'Puyang'
}, {
    pcode: '51',
    city: '攀枝花',
    code: '510400',
    level: 1,
    initial: 'P',
    lonlat:"101.71786,26.58477",
    short: 'Panzhihua'
}, {
    pcode: '62',
    city: '平凉',
    code: '620800',
    level: 1,
    initial: 'P',
    lonlat:"106.68192,35.54123",
    short: 'Pingliang'
}, {
    pcode: '13',
    city: '秦皇岛',
    code: '130300',
    level: 1,
    initial: 'Q',
    lonlat:"119.58812,39.93978",
    short: 'Qinhuangdao'
}, {
    pcode: '23',
    city: '齐齐哈尔',
    code: '230200',
    level: 1,
    initial: 'Q',
    lonlat:"123.96368,47.34471",
    short: 'Qiqihaer'
}, {
    pcode: '23',
    city: '七台河',
    code: '230900',
    level: 1,
    initial: 'Q',
    lonlat:"131.00545,45.77004",
    short: 'Qitaihe'
}, {
    pcode: '33',
    city: '衢州',
    code: '330800',
    level: 1,
    initial: 'Q',
    lonlat:"118.8763,28.95445",
    short: 'Quzhou'
}, {
    pcode: '35',
    city: '泉州',
    code: '350500',
    level: 1,
    initial: 'Q',
    lonlat:"118.58938,24.9109",
    short: 'Quanzhou'
}, {
    pcode: '37',
    city: '青岛',
    code: '370200',
    level: 1,
    initial: 'Q',
    lonlat:"120.37714,36.06587",
    short: 'Qingdao'
}, {
    pcode: '44',
    city: '清远',
    code: '441800',
    level: 1,
    initial: 'Q',
    lonlat:"113.05075,23.68425",
    short: 'Qingyuan'
}, {
    pcode: '45',
    city: '钦州',
    code: '450700',
    level: 1,
    initial: 'Q',
    lonlat:"108.62068,21.96722",
    short: 'Qinzhou'
}, {
    pcode: '52',
    city: '黔西南州',
    code: '522300',
    level: 1,
    initial: 'Q',
    lonlat:"104.89645,25.09312",
    short: 'Qianxinan'
}, {
    pcode: '52',
    city: '黔东南州',
    code: '522600',
    level: 1,
    initial: 'Q',
    lonlat:"107.97458,26.5869",
    short: 'Qiandongnan'
}, {
    pcode: '52',
    city: '黔南州',
    code: '522700',
    level: 1,
    initial: 'Q',
    lonlat:"107.51233,26.27065",
    short: 'Qiannan'
}, {
    pcode: '53',
    city: '曲靖',
    code: '530300',
    level: 1,
    initial: 'Q',
    lonlat:"103.79586,25.50326",
    short: 'Qujing'
}, {
    pcode: '62',
    city: '庆阳',
    code: '621000',
    level: 1,
    initial: 'Q',
    lonlat:"107.63754,35.73259",
    short: 'Qingyang'
}, {
    pcode: '37',
    city: '日照',
    code: '371100',
    level: 1,
    initial: 'R',
    lonlat:"119.49154,35.40281",
    short: 'Rizhao'
}, {
    pcode: '54',
    city: '日喀则地区',
    code: '542300',
    level: 1,
    initial: 'R',
    lonlat:"88.87988,29.26492",
    short: 'Rikaze'
}, {
    pcode: '13',
    city: '石家庄',
    code: '130100',
    level: 5,
    initial: 'S',
    lonlat:"88.87988,29.26492",
    short: 'Shijiazhuang'
}, {
    pcode: '31',
    city: '上海',
    code: '310000',
    level: 1,
    initial: 'S',
    lonlat:"121.44645,31.21773",
    short: 'Shanghai'
}, {
    pcode: '14',
    city: '朔州',
    code: '140600',
    level: 1,
    initial: 'S',
    lonlat:"112.4298,39.33105",
    short: 'Shuozhou'
}, {
    pcode: '21',
    city: '沈阳',
    code: '210100',
    level: 5,
    initial: 'S',
    lonlat:"123.42577,41.80385",
    short: 'Shenyang'
}, {
    pcode: '53',
    city: '普洱',
    code: '530800',
    level: 1,
    initial: 'P',
    lonlat:"100.97521,22.78187",
    short: 'Puer'
}, {
    pcode: '22',
    city: '四平',
    code: '220300',
    level: 1,
    initial: 'S',
    lonlat:"124.34382,43.16342",
    short: 'Siping'
}, {
    pcode: '22',
    city: '松原',
    code: '220700',
    level: 1,
    initial: 'S',
    lonlat:"124.83452,45.15042",
    short: 'Songyuan'
}, {
    pcode: '23',
    city: '双鸭山',
    code: '230500',
    level: 1,
    initial: 'S',
    lonlat:"131.15452,46.63883",
    short: 'Shuangyashan'
}, {
    pcode: '23',
    city: '绥化',
    code: '231200',
    level: 1,
    initial: 'S',
    lonlat:"126.9896,46.63752",
    short: 'Suihua'
}, {
    pcode: '32',
    city: '苏州',
    code: '320500',
    level: 1,
    initial: 'S',
    lonlat:"120.61642,31.30401",
    short: 'Suzhou'
}, {
    pcode: '32',
    city: '宿迁',
    code: '321300',
    level: 1,
    initial: 'S',
    lonlat:"118.29509,33.95513",
    short: 'Suqian'
}, {
    pcode: '33',
    city: '绍兴',
    code: '330600',
    level: 1,
    initial: 'S',
    lonlat:"120.57757,30.00338",
    short: 'Shaoxing'
}, {
    pcode: '34',
    city: '宿州',
    code: '341300',
    level: 1,
    initial: 'S',
    lonlat:"116.9873,33.6391",
    short: 'Suzhou'
}, {
    pcode: '35',
    city: '三明',
    code: '350400',
    level: 1,
    initial: 'S',
    lonlat:"117.63017,26.2658",
    short: 'Sanming'
}, {
    pcode: '36',
    city: '上饶',
    code: '361100',
    level: 1,
    initial: 'S',
    lonlat:"117.96887,28.46339",
    short: 'Shangrao'
}, {
    pcode: '41',
    city: '三门峡',
    code: '411200',
    level: 1,
    initial: 'S',
    lonlat:"111.19463,34.7787",
    short: 'Sanmenxia'
}, {
    pcode: '41',
    city: '商丘',
    code: '411400',
    level: 1,
    initial: 'S',
    lonlat:"115.62863,34.43644",
    short: 'Shangqiu'
}, {
    pcode: '42',
    city: '十堰',
    code: '420300',
    level: 1,
    initial: 'S',
    lonlat:"110.77054,32.64407",
    short: 'Shiyan'
}, {
    pcode: '42',
    city: '随州',
    code: '421300',
    level: 1,
    initial: 'S',
    lonlat:"113.36424,31.72359",
    short: 'Suizhou'
}, {
    pcode: '43',
    city: '邵阳',
    code: '430500',
    level: 1,
    initial: 'S',
    lonlat:"111.47247,27.24176",
    short: 'Shaoyang'
}, {
    pcode: '44',
    city: '韶关',
    code: '440200',
    level: 1,
    initial: 'S',
    lonlat:"113.60205,24.81135",
    short: 'Shaoguan'
}, {
    pcode: '44',
    city: '深圳',
    code: '440300',
    level: 1,
    initial: 'S',
    lonlat:"114.07989,22.55122",
    short: 'Shenzhen'
}, {
    pcode: '44',
    city: '汕头',
    code: '440500',
    level: 1,
    initial: 'S',
    lonlat:"116.6825,23.36437",
    short: 'Shantou'
}, {
    pcode: '44',
    city: '汕尾',
    code: '441500',
    level: 1,
    initial: 'S',
    lonlat:"115.35309,22.77263",
    short: 'Shanwei'
}, {
    pcode: '46',
    city: '三亚',
    code: '460200',
    level: 1,
    initial: 'S',
    lonlat:"109.50715,18.25414",
    short: 'Sanya'
}, {
    pcode: '51',
    city: '遂宁',
    code: '510900',
    level: 1,
    initial: 'S',
    lonlat:"105.58067,30.50991",
    short: 'Suining'
}, {
    pcode: '54',
    city: '山南',
    code: '542200',
    level: 1,
    initial: 'S',
    lonlat:"91.77,29.23793",
    short: 'Shannan'
}, {
    pcode: '61',
    city: '商洛',
    code: '611000',
    level: 1,
    initial: 'S',
    lonlat:"109.9363,33.86452",
    short: 'Shangluo'
}, {
    pcode: '64',
    city: '石嘴山',
    code: '640200',
    level: 1,
    initial: 'S',
    lonlat:"106.37003,39.01795",
    short: 'Shizuishan'
}, {
    pcode: '13',
    city: '唐山',
    code: '130200',
    level: 1,
    initial: 'T',
    lonlat:"118.17426,39.62923",
    short: 'Tangshan'
}, {
    pcode: '14',
    city: '太原',
    code: '140100',
    level: 5,
    initial: 'T',
    lonlat:"112.56449,37.87344",
    short: 'Taiyuan'
}, {
    pcode: '15',
    city: '通辽',
    code: '150500',
    level: 1,
    initial: 'T',
    lonlat:"122.26398,43.61723",
    short: 'Tongliao'
}, {
    pcode: '21',
    city: '铁岭',
    code: '211200',
    level: 1,
    initial: 'T',
    lonlat:"123.83654,42.28407",
    short: 'Tieling'
}, {
    pcode: '22',
    city: '通化',
    code: '220500',
    level: 1,
    initial: 'T',
    lonlat:"125.93399,41.72609",
    short: 'Tonghua'
}, {
    pcode: '32',
    city: '泰州',
    code: '321200',
    level: 1,
    initial: 'T',
    lonlat:"119.91017,32.49493",
    short: 'Taizhou'
}, {
    pcode: '33',
    city: '台州',
    code: '331000',
    level: 1,
    initial: 'T',
    lonlat:"121.42248,28.66317",
    short: 'Taizhou'
}, {
    pcode: '34',
    city: '铜陵',
    code: '340700',
    level: 1,
    initial: 'T',
    lonlat:"117.78641,30.91268",
    short: 'Tongling'
}, {
    pcode: '37',
    city: '泰安',
    code: '370900',
    level: 1,
    initial: 'T',
    lonlat:"117.12697,36.1881",
    short: 'Taian'
}, {
    pcode: '52',
    city: '铜仁',
    code: '522200',
    level: 1,
    initial: 'T',
    lonlat:"109.18851,27.72334",
    short: 'Tongren'
}, {
    pcode: '61',
    city: '铜川',
    code: '610200',
    level: 1,
    initial: 'T',
    lonlat:"108.94044,34.89782",
    short: 'Tongchuan'
}, {
    pcode: '62',
    city: '天水',
    code: '620500',
    level: 1,
    initial: 'T',
    lonlat:"105.72069,34.58236",
    short: 'Tianshui'
}, {
    pcode: '65',
    city: '吐鲁番地区',
    code: '652100',
    level: 1,
    initial: 'T',
    lonlat:"89.17918,42.94513",
    short: 'Tulufan'
}, {
    pcode: '65',
    city: '塔城地区',
    code: '654200',
    level: 1,
    initial: 'T',
    lonlat:"82.98134,46.74591",
    short: 'Tachengdi'
}, {
    pcode: '12',
    city: '天津',
    code: '120000',
    level: 1,
    initial: 'T',
    lonlat:"117.20542,39.1468",
    short: 'Tianjin'
}, {
    pcode: '15',
    city: '乌海',
    code: '150300',
    level: 1,
    initial: 'W',
    lonlat:"106.82115,39.67102",
    short: 'Wuhai'
}, {
    pcode: '15',
    city: '乌兰察布',
    code: '150900',
    level: 1,
    initial: 'W',
    lonlat:"113.10711,41.03354",
    short: 'Wulanchabu'
}, {
    pcode: '32',
    city: '无锡',
    code: '320200',
    level: 1,
    initial: 'W',
    lonlat:"120.29849,31.56746",
    short: 'Wuxi'
}, {
    pcode: '33',
    city: '温州',
    code: '330300',
    level: 1,
    initial: 'W',
    lonlat:"120.69534,27.9982",
    short: 'Wenzhou'
}, {
    pcode: '34',
    city: '芜湖',
    code: '340200',
    level: 1,
    initial: 'W',
    lonlat:"118.36223,31.33398",
    short: 'Wuhu'
}, {
    pcode: '37',
    city: '潍坊',
    code: '370700',
    level: 1,
    initial: 'W',
    lonlat:"119.10535,36.70267",
    short: 'Weifang'
}, {
    pcode: '37',
    city: '威海',
    code: '371000',
    level: 1,
    initial: 'W',
    lonlat:"122.1139,37.51269",
    short: 'Weihai'
}, {
    pcode: '42',
    city: '武汉',
    code: '420100',
    level: 5,
    initial: 'W',
    lonlat:"114.27367,30.58385",
    short: 'Wuhan'
}, {
    pcode: '45',
    city: '梧州',
    code: '450400',
    level: 1,
    initial: 'W',
    lonlat:"111.30082,23.47852",
    short: 'Wuzhou'
}, {
    pcode: '53',
    city: '文山州',
    code: '532600',
    level: 1,
    initial: 'W',
    lonlat:"104.23733,23.37962",
    short: 'Wenshan'
}, {
    pcode: '61',
    city: '渭南',
    code: '610500',
    level: 1,
    initial: 'W',
    lonlat:"109.5041,34.50048",
    short: 'Weinan'
}, {
    pcode: '62',
    city: '武威',
    code: '620600',
    level: 1,
    initial: 'W',
    lonlat:"102.63286,37.92781",
    short: 'Wuwei'
}, {
    pcode: '64',
    city: '吴忠',
    code: '640300',
    level: 1,
    initial: 'W',
    lonlat:"106.19908,37.98128",
    short: 'Wuzhong'
}, {
    pcode: '65',
    city: '乌鲁木齐',
    code: '650100',
    level: 5,
    initial: 'W',
    lonlat:"87.61379,43.8253",
    short: 'Wulumuqi'
}, {
    pcode: '13',
    city: '邢台',
    code: '130500',
    level: 1,
    initial: 'X',
    lonlat:"114.48258,37.0518",
    short: 'Xingtai'
}, {
    pcode: '14',
    city: '忻州',
    code: '140900',
    level: 1,
    initial: 'X',
    lonlat:"112.73027,38.40761",
    short: 'Xinzhou'
}, {
    pcode: '15',
    city: '兴安',
    code: '152200',
    level: 1,
    initial: 'X',
    lonlat:"122.06584,46.06962",
    short: 'Xinganmeng'
}, {
    pcode: '15',
    city: '锡林郭勒',
    code: '152500',
    level: 1,
    initial: 'X',
    lonlat:"116.08588,43.94517",
    short: 'Xilinguolemeng'
}, {
    pcode: '32',
    city: '徐州',
    code: '320300',
    level: 1,
    initial: 'X',
    lonlat:"117.18587,34.26105",
    short: 'Xuzhou'
}, {
    pcode: '34',
    city: '宣城',
    code: '341800',
    level: 1,
    initial: 'X',
    lonlat:"118.75353,30.94299",
    short: 'Xuancheng'
}, {
    pcode: '35',
    city: '厦门',
    code: '350200',
    level: 1,
    initial: 'X',
    lonlat:"118.11116,24.48748",
    short: 'Xiamen'
}, {
    pcode: '36',
    city: '新余',
    code: '360500',
    level: 1,
    initial: 'X',
    lonlat:"114.9323,27.81228",
    short: 'Xinyu'
}, {
    pcode: '41',
    city: '新乡',
    code: '410700',
    level: 1,
    initial: 'X',
    lonlat:"113.87282,35.2925",
    short: 'Xinxiang'
}, {
    pcode: '41',
    city: '许昌',
    code: '411000',
    level: 1,
    initial: 'X',
    lonlat:"113.81858,34.02859",
    short: 'Xuchang'
}, {
    pcode: '41',
    city: '信阳',
    code: '411500',
    level: 1,
    initial: 'X',
    lonlat:"114.07079,32.13063",
    short: 'Xinyang'
}, {
    pcode: '42',
    city: '襄阳',
    code: '420600',
    level: 1,
    initial: 'X',
    lonlat:"112.15504,32.07435",
    short: 'Xiangyang'
}, {
    pcode: '42',
    city: '孝感',
    code: '420900',
    level: 1,
    initial: 'X',
    lonlat:"113.91096,30.92731",
    short: 'Xiaogan'
}, {
    pcode: '42',
    city: '咸宁',
    code: '421200',
    level: 1,
    initial: 'X',
    lonlat:"114.32882,29.83411",
    short: 'Xianning'
}, {
    pcode: '43',
    city: '湘潭',
    code: '430300',
    level: 1,
    initial: 'X',
    lonlat:"112.91507,27.84421",
    short: 'Xiangtan'
}, {
    pcode: '43',
    city: '湘西州',
    code: '433100',
    level: 1,
    initial: 'X',
    lonlat:"109.73666,28.31248",
    short: 'Xiangxi'
}, {
    pcode: '53',
    city: '西双版纳州',
    code: '532800',
    level: 1,
    initial: 'X',
    lonlat:"100.79622,22.01029",
    short: 'Xishuangbanna'
}, {
    pcode: '61',
    city: '西安',
    code: '610100',
    level: 5,
    initial: 'X',
    lonlat:"108.93954,34.26646",
    short: 'Xian'
}, {
    pcode: '61',
    city: '咸阳',
    code: '610400',
    level: 1,
    initial: 'X',
    lonlat:"108.70479,34.33076",
    short: 'Xianyang'
}, {
    pcode: '63',
    city: '西宁',
    code: '630100',
    level: 5,
    initial: 'X',
    lonlat:"101.78503,36.60873",
    short: 'Xining'
}, {
    pcode: '90',
    city: '香港',
    code: '900100',
    level: 5,
    initial: 'X',
    lonlat:"114.1667,22.29377",
    short: 'Xianggang'
}, {
    pcode: '14',
    city: '阳泉',
    code: '140300',
    level: 1,
    initial: 'Y',
    lonlat:"113.56003,37.86396",
    short: 'Yangquan'
}, {
    pcode: '14',
    city: '运城',
    code: '140800',
    level: 1,
    initial: 'Y',
    lonlat:"110.9912,35.03289",
    short: 'Yuncheng'
}, {
    pcode: '21',
    city: '营口',
    code: '210800',
    level: 1,
    initial: 'Y',
    lonlat:"122.22972,40.66525",
    short: 'Yingkou'
}, {
    pcode: '22',
    city: '延边州',
    code: '222400',
    level: 1,
    initial: 'Y',
    lonlat:"129.5067,42.9044",
    short: 'Yanbian'
}, {
    pcode: '23',
    city: '伊春',
    code: '230700',
    level: 1,
    initial: 'Y',
    lonlat:"128.88932,47.72347",
    short: 'Yichun'
}, {
    pcode: '32',
    city: '盐城',
    code: '320900',
    level: 1,
    initial: 'Y',
    lonlat:"120.1331,33.38387",
    short: 'Yancheng'
}, {
    pcode: '32',
    city: '扬州',
    code: '321000',
    level: 1,
    initial: 'Y',
    lonlat:"119.43625,32.39117",
    short: 'Yangzhou'
}, {
    pcode: '36',
    city: '鹰潭',
    code: '360600',
    level: 1,
    initial: 'Y',
    lonlat:"117.03383,28.24087",
    short: 'Yingtan'
}, {
    pcode: '36',
    city: '宜春',
    code: '360900',
    level: 1,
    initial: 'Y',
    lonlat:"114.37242,27.7954",
    short: 'Yichun'
}, {
    pcode: '37',
    city: '烟台',
    code: '370600',
    level: 1,
    initial: 'Y',
    lonlat:"121.37818,37.53272",
    short: 'Yantai'
}, {
    pcode: '42',
    city: '宜昌',
    code: '420500',
    level: 1,
    initial: 'Y',
    lonlat:"111.31567,30.70953",
    short: 'Yichang'
}, {
    pcode: '43',
    city: '岳阳',
    code: '430600',
    level: 1,
    initial: 'Y',
    lonlat:"113.12781,29.37274",
    short: 'Yueyang'
}, {
    pcode: '43',
    city: '益阳',
    code: '430900',
    level: 1,
    initial: 'Y',
    lonlat:"112.3547,28.58099",
    short: 'Yiyang'
}, {
    pcode: '43',
    city: '永州',
    code: '431100',
    level: 1,
    initial: 'Y',
    lonlat:"111.59608,26.45247",
    short: 'Yongzhou'
}, {
    pcode: '44',
    city: '阳江',
    code: '441700',
    level: 1,
    initial: 'Y',
    lonlat:"112.00138,21.853075",
    short: 'Yangjiang'
}, {
    pcode: '44',
    city: '云浮',
    code: '445300',
    level: 1,
    initial: 'Y',
    lonlat:"112.0373,22.91385",
    short: 'Yunfu'
}, {
    pcode: '45',
    city: '玉林',
    code: '450900',
    level: 1,
    initial: 'Y',
    lonlat:"110.15404,22.62443",
    short: 'Yulin'
}, {
    pcode: '51',
    city: '宜宾',
    code: '511500',
    level: 1,
    initial: 'Y',
    lonlat:"104.63997,28.75961",
    short: 'Yibin'
}, {
    pcode: '51',
    city: '雅安',
    code: '511800',
    level: 1,
    initial: 'Y',
    lonlat:"103.00194,29.9851",
    short: 'Yaan'
}, {
    pcode: '53',
    city: '玉溪',
    code: '530400',
    level: 1,
    initial: 'Y',
    lonlat:"102.54317,24.34953",
    short: 'Yuxi'
}, {
    pcode: '61',
    city: '延安',
    code: '610600',
    level: 1,
    initial: 'Y',
    lonlat:"109.48628,36.59523",
    short: 'Yanan'
}, {
    pcode: '61',
    city: '榆林',
    code: '610800',
    level: 1,
    initial: 'Y',
    lonlat:"109.72781,38.28487",
    short: 'Yulin'
}, {
    pcode: '63',
    city: '玉树州',
    code: '632700',
    level: 1,
    initial: 'Y',
    lonlat:"97.00887,33.0025",
    short: 'Yushu'
}, {
    pcode: '64',
    city: '银川',
    code: '640100',
    level: 5,
    initial: 'Y',
    lonlat:"106.27056,38.46654",
    short: 'Yinchuan'
}, {
    pcode: '65',
    city: '伊犁州',
    code: '654000',
    level: 1,
    initial: 'Y',
    lonlat:"81.32362,43.9166",
    short: 'Yilihasake'
}, {
    pcode: '13',
    city: '张家口',
    code: '130700',
    level: 1,
    initial: 'Z',
    lonlat:"114.88499,40.79123",
    short: 'Zhangjiakou'
}, {
    pcode: '32',
    city: '镇江',
    code: '321100',
    level: 1,
    initial: 'Z',
    lonlat:"119.44326,32.2061",
    short: 'Zhenjiang'
}, {
    pcode: '33',
    city: '舟山',
    code: '330900',
    level: 1,
    initial: 'Z',
    lonlat:"122.10703,30.01912",
    short: 'Zhoushan'
}, {
    pcode: '35',
    city: '漳州',
    code: '350600',
    level: 1,
    initial: 'Z',
    lonlat:"117.65276,24.5127",
    short: 'Zhangzhou'
}, {
    pcode: '37',
    city: '淄博',
    code: '370300',
    level: 1,
    initial: 'Z',
    lonlat:"118.05797,36.79101",
    short: 'Zibo'
}, {
    pcode: '37',
    city: '枣庄',
    code: '370400',
    level: 1,
    initial: 'Z',
    lonlat:"117.55301,34.85346",
    short: 'Zaozhuang'
}, {
    pcode: '41',
    city: '郑州',
    code: '410100',
    level: 5,
    initial: 'Z',
    lonlat:"113.64131,34.75794",
    short: 'Zhengzhou'
}, {
    pcode: '41',
    city: '周口',
    code: '411600',
    level: 1,
    initial: 'Z',
    lonlat:"114.6418,33.62502",
    short: 'Zhoukou'
}, {
    pcode: '41',
    city: '驻马店',
    code: '411700',
    level: 1,
    initial: 'Z',
    lonlat:"114.02528,32.97729",
    short: 'Zhumadian'
}, {
    pcode: '43',
    city: '株洲',
    code: '430200',
    level: 1,
    initial: 'Z',
    lonlat:"113.13966,27.83531",
    short: 'Zhuzhou'
}, {
    pcode: '43',
    city: '张家界',
    code: '430800',
    level: 1,
    initial: 'Z',
    lonlat:"110.47497,29.12074",
    short: 'Zhangjiajie'
}, {
    pcode: '44',
    city: '珠海',
    code: '440400',
    level: 1,
    initial: 'Z',
    lonlat:"113.57133,22.27465",
    short: 'Zhuhai'
}, {
    pcode: '44',
    city: '湛江',
    code: '440800',
    level: 1,
    initial: 'Z',
    lonlat:"110.355,21.27317",
    short: 'Zhanjiang'
}, {
    pcode: '44',
    city: '肇庆',
    code: '441200',
    level: 1,
    initial: 'Z',
    lonlat:"112.46915,23.07974",
    short: 'Zhaoqing'
}, {
    pcode: '44',
    city: '中山',
    code: '442000',
    level: 1,
    initial: 'Z',
    lonlat:"113.37351,22.52591",
    short: 'Zhongshan'
}, {
    pcode: '51',
    city: '自贡',
    code: '510300',
    level: 1,
    initial: 'Z',
    lonlat:"104.77564,29.34185",
    short: 'Zigong'
}, {
    pcode: '51',
    city: '资阳',
    code: '512000',
    level: 1,
    initial: 'Z',
    lonlat:"104.63974,30.12562",
    short: 'Ziyang'
}, {
    pcode: '52',
    city: '遵义',
    code: '520300',
    level: 1,
    initial: 'Z',
    lonlat:"106.9235,27.69327",
    short: 'Zunyi'
}, {
    pcode: '53',
    city: '昭通',
    code: '530600',
    level: 1,
    initial: 'Z',
    lonlat:"103.71445,27.33284",
    short: 'Zhaotong'
}, {
    pcode: '62',
    city: '张掖',
    code: '620700',
    level: 1,
    initial: 'Z',
    lonlat:"100.45529,38.93545",
    short: 'Zhangye'
}, {
    pcode: '64',
    city: '中卫',
    code: '640500',
    level: 1,
    initial: 'Z',
    lonlat:"105.1854,37.51549",
    short: 'Zhongwei'
}, {
    pcode: '90',
    city: '台湾',
    code: '900300',
    level: 1,
    initial: '',
    lonlat:"121.05035,23.84134",
    short: 'Taiwan'
}]

let provinces = {
    p34: { name: '安徽', code: '34', initial: 'A', cities: [] },
    p35: { name: '福建', code: '35', initial: 'F', cities: [] },
    p44: { name: '广东', code: '44', initial: 'G', cities: [] },
    p45: { name: '广西', code: '45', initial: 'G', cities: [] },
    p52: { name: '贵州', code: '52', initial: 'G', cities: [] },
    p62: { name: '甘肃', code: '62', initial: 'G', cities: [] },
    p13: { name: '河北', code: '13', initial: 'H', cities: [] },
    p23: { name: '黑龙江', code: '23', initial: 'H', cities: [] },
    p41: { name: '河南', code: '41', initial: 'H',cities: [] },
    p42: { name: '湖北', code: '42', initial: 'H', cities: [] },
    p43: { name: '湖南', code: '43', initial: 'H', cities: [] },
    p46: { name: '海南', code: '46', initial: 'H', cities: [] },
    p22: { name: '吉林', code: '22', initial: 'J',  cities: [] },
    p32: { name: '江苏', code: '32', initial: 'J',  cities: [] },
    p36: { name: '江西', code: '36', initial: 'J',  cities: [] },
    p21: { name: '辽宁', code: '21', initial: 'L',  cities: [] },
    p15: { name: '内蒙古', code: '15', initial: 'N',  cities: [] },
    p64: { name: '宁夏', code: '64', initial: 'N',  cities: [] },
    p63: { name: '青海', code: '63', initial: 'Q',  cities: [] },
    p14: { name: '山西', code: '14', initial: 'S',  cities: [] },
    p37: { name: '山东', code: '37', initial: 'S',  cities: [] },
    p51: { name: '四川', code: '51', initial: 'S',  cities: [] },
    p61: { name: '陕西', code: '61', initial: 'S',  cities: [] },
    p54: { name: '西藏', code: '54', initial: 'X',  cities: [] },
    p65: { name: '新疆', code: '65', initial: 'X',  cities: [] },
    p53: { name: '云南', code: '53', initial: 'Y',  cities: [] },
    p33: { name: '浙江', code: '33', initial: 'Z',  cities: [] },
    p90: { name: '港澳台', code: '90', initial: '港澳台', cities: [] }
};
let cityList = {};

allCities.forEach(c => {
    if(c.initial){
        if(!cityList[c.initial]){ cityList[c.initial] = []; }
        cityList[c.initial].push({ initial: c.initial, cities: c});
    }
    let p = provinces[`p${c.pcode}`];
    if(!p){ return; }
    p.cities.push(c);
});

let _hot = ['北京', '上海', '广州', '深圳', '天津', '重庆', '成都', '杭州', '武汉', '香港', '澳门'];
let hotCities = new Array(_hot.length);
export default {
    getProvinceData () {
        let list = [], navInfo = {};
        Object.keys(provinces).forEach((k, i) => {
            provinces[k].cities = provinces[k].cities.sort((c1, c2) => c2.level - c1.level);
            list.push(provinces[k]);
            if(!/^[A-Z]$/.test(provinces[k].initial) || navInfo[provinces[k].initial] !== undefined){ return; }
            navInfo[provinces[k].initial] = i;
        });
        return { list, navInfo };
    },
    getCityList () {
        let list = [];
        Object.keys(cityList).forEach((k) => { if(k.code != '900300'){ list.push(cityList[k]); }});
        return list;
    },
    getInitials (type) {
        if(![1, 2].includes(type)){ return []; }
        let set = [];
        if(type == 1){
            Object.keys(provinces).forEach(k => {
                if(set.includes(provinces[k].initial)){ return; }
                set.push(provinces[k].initial);
            });
        }else{
            allCities.forEach(val => {
                if(set.includes(val.initial)){ return; }
                set.push(val.initial);
            });
        }
        return set.filter(v => /^[A-Z]$/.test(v));
    },
    getCitiesByPinyin (py) {
        let list = [];
        if(/^[a-z]+$/i.test(py)){
            if(py.length < 2){ return list; }
            let _exp = new RegExp(`\^${py}`, 'i');
            allCities.forEach(c => {
                if(list.length >= 8){ return; }
                if(c.initial != py[0].toUpperCase()){ return; }
                if(c.code == '900300'){ return; }   //排除台湾
                if(!_exp.test(c.short)){ return; }
                list.push(c);
            });
        }else if(/^[\u4e00-\u9fa5]+$/.test(py)){
            allCities.forEach(c => { if(list.length < 8 && c.city.includes(py)){ return list.push(c); } });
        }
        return list;
    },
    getHotCities () {
        if(!!hotCities[0]){ return hotCities; }
        allCities.forEach(c => {
            let _idx = _hot.indexOf(c.city);
            if(_idx == -1){ return; }
            hotCities[_idx] = c;
        });
        return hotCities;
    },
    getCityByCode (code) {
        let city;
        if(code.length == 2){
            city = provinces[`p${code}`];
            if(city){ city = JSON.parse(JSON.stringify(city, ['name', 'code', 'initial'])); }
        }else if(code.length == 6){
            city = allCities.filter(c => c.code === code)[0];
            if(!city){ return null; }
        }
        return city;
    }
}